module.exports = __webpack_public_path__ + "img/icon_bank@3x.d0bbb7eb.png";